<template>

  <div class="nav-100-main-container p-0">

    <header class="nav-100-header">
      <m-a :href="{name:'Home'}">
        <h3 class="text-light font-weight-bold text-center w-100 pt-3">
          {{ findAttributeOnSiteInfo('site_name')[0] }}</h3>
      </m-a>
      <div class="nav-100-menu-toggle">
        <button class="nav-100-menu-button" @click="onclickMenu">
          <b-icon icon="list"/>
        </button>
      </div>
    </header>

    <Transition name="menu">
      <nav class="nav-100-pages-nav" v-show="showMenu">
        <main-menu v-show="haveMainMenu"/>
        <slot></slot>
      </nav>
    </Transition>

  </div>

</template>

<script>
import MainMenu from "./MainMenu";

export default {
  name: "Nav100",
  props: ['haveMainMenu'],
  components: {MainMenu},
  data() {
    return {
      showMenu: false,
      page: ''
    }
  },
  methods: {
    onclickMenu() {
      this.showMenu = !this.showMenu
      this.page.classList.toggle('nav-100-menu-closed')
      this.page.classList.toggle('nav-100-menu-opened', this.showMenu === true)
      return true
    },
    runAnimation() {
      this.showMenu = false
      this.page.classList.add('nav-100-menu-closed')
    }
  },
  async mounted() {
    this.page = document.querySelector('.nav-100-transition')
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.$nextTick(this.runAnimation);
      }
    }
  }
}
</script>

<style>
.nav-100-transition {
  position: relative;
  top: 200px;
  transition: all 0.5s;
  transform: scale(0.7, 1);
}

.nav-100-full-screen {
  min-height: 100vh;
}

.nav-100-header {
  position: relative;
  left: 0;
  height: 60px;
  z-index: 10;
  background-color: var(--primary);
}

.nav-100-menu-toggle {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: var(--dark);
  height: 60px;
  width: 60px;
}

.nav-100-header .nav-100-menu-toggle .nav-100-menu-button {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.nav-100-pages-nav .nav-100-link {
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  text-decoration: none;
  position: relative;
}

.nav-100-pages-nav .nav-100-pages-nav__item {
  margin: 0 13px;
}

.nav-100-pages-nav .nav-100-link:after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 1px;
  left: auto;
  background: #fff;
  right: 0;
  transition: ease all 0.3s;
  width: 0;
}

.nav-100-pages-nav .nav-100-link:hover:after {
  width: 100%;
  right: auto;
  left: 0;
}

.nav-100-pages-nav {
  display: -webkit-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  text-align: center;
  background: var(--dark);
  height: auto;
  position: relative;
  z-index: 25;
  padding: 15px 0;
}

.nav-100-menu-button {
  width: 60px;
  height: 60px;
  padding: 0;
  cursor: pointer;
  border: none;
  outline: none;
  background: var(--dark);
  color: white;
  font-size: 30px;
}

.nav-100-main-container {
  background-color: var(--light-cyan);
}

.nav-100-menu-opened {
  position: relative;
  top: 0 !important;
  transform: scale(0.7, 1);
}

.nav-100-menu-closed {
  position: relative;
  top: 0 !important;
  transform: scale(1, 1) !important;
}

@media screen and (max-width: 768px) {
  .nav-100-header {
    width: 100%;
  }
}

/***************************************/

.menu-enter-active {
  animation: move-up .4s;
  transition: all ease-in-out .4s;
}

.menu-leave-active {
  animation: move-down .4s;
  transition: all ease-in-out .4s;
}

.menu-enter-from,
.menu-leave-to {
  height: 0;
  opacity: 0;
}

@keyframes move-up {
  0% {
    height: auto;
    opacity: 0;
  }
  100% {
    opacity: 1;
    height: auto;
  }
}

@keyframes move-down {
  0% {
    height: auto;
    opacity: 1;
  }
  100% {
    opacity: 0;
    height: auto;
  }
}
</style>